module.exports = __webpack_public_path__ + "img/Twitter.f9277aa4.svg";